let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hzTu5")).then(() => parcelRequire('7sFFK'));